import { Action, Dispatch } from "redux";
import axios from "../../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import * as action_types from "./constants";
import { CrewYardListingType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getCrewYardListing = (payload: CrewYardListingType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(
        `${baseURL}getCrewYardListing`,
        payload
      );
      dispatch({
        type: action_types.CREW_YARD_LISTING,
        data: { payload: data?.data, loading: false, count: data?.count },
      });
    } catch (error) {
      dispatch({
        type: action_types.CREW_YARD_LISTING,
        payload: { loading: false },
      });
    }
  };
};

export const removeCrewYardListingData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.CREW_YARD_LISTING,
      data: { payload: {}, loading: true },
    });
  };
};

export const getCrewYardDetailById = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getCrewYardDetailById/${id}`);
      dispatch({
        type: action_types.CREW_YARD_DETAIL_DATA,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.CREW_YARD_DETAIL_DATA,
        data: { loading: false },
      });
    }
  };
};

export const removeCrewYardDetailData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.CREW_YARD_DETAIL_DATA,
      data: { payload: {}, loading: true },
    });
  };
};

export const getCrewYardFormData = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.get(`${baseURL}getCrewYardFormData/${id}`);
      dispatch({
        type: action_types.CREW_YARD_FORM_DATA,
        data: { payload: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.CREW_YARD_FORM_DATA,
        data: { loading: false },
      });
    }
  };
};
